import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import { useLang } from "../../../Hooks";
import { ReportHeader } from "../Shared/Components/ReportHeader";
import { ReportToolbar } from "../Shared/Components/ReportToolbar";
import { reportToolbarStyles } from "../Shared/Styles/reportToolbarStyles";
import { useTimeSeriesCommonSizeData } from "./hooks/useTimeSeriesCommonSizeData";
import { TimeSeriesCommonSizeActions } from "./Components/TimeSeriesCommonSizeActions";
import { TimeSeriesCommonSizeFilters } from "./Components/TimeSeriesCommonSizeFilters";
import { TimeSeriesCommonSizeTable } from "./Components/TimeSeriesCommonSizeTable";

export default function TimeSeriesCommonSize() {
  const { texts } = useLang();
  const {
    applyFilters,
    changeCurrency,
    exportReport,
    filters,
    isExporting,
    isLoadingReport,
    reportData,
    toggleRow,
  } = useTimeSeriesCommonSizeData();

  return (
    <Box>
      <Flex {...reportToolbarStyles.headerRow}>
        <ReportHeader
          title={
            texts.reports?.timeSeriesCommonSize || "Time Series Common Size"
          }
          subtitle={texts.reports?.financialOverview || "Financial overview"}
        />
        <ReportToolbar>
          <TimeSeriesCommonSizeFilters
            currentFilters={filters}
            onApplyFilters={applyFilters}
            onCurrencyChange={changeCurrency}
          />
          <TimeSeriesCommonSizeActions
            isExporting={isExporting}
            onExport={exportReport}
          />
        </ReportToolbar>
      </Flex>
      <TimeSeriesCommonSizeTable
        data={reportData}
        isLoading={isLoadingReport}
        onToggleRow={toggleRow}
      />
    </Box>
  );
}
